/* eslint-disable */
import en from 'vuetify/lib/locale/en';

export default {
  ...en,
  //NOMES IDIOMAS
  idioma: 'Language',
  // GERAL
  meusDados: 'My profile',
  sair: 'Logout',
  pesquisar: 'Search',
  kanban: 'Kanban',
  todosClientes: 'All companies',
  null: 'N/I',
  recusar: 'Refuse',
  aceitar: 'Accept',
  selecionados: 'Selected',
  // NOVAS ATUALIZAÇÕES
  novasAtualizacoes: 'UPDATES!',
  // FILTROS
  pesquisarBy: 'Search processes by code or reference',
  filtros: 'Filters',
  download: 'Download',
  periodo: 'Time range:',
  tipoData: 'Date type:',
  mostrarEncerrados: 'Show closed processes',
  encerrado: 'Closed',
  Abertura: 'Opening',
  ETD: 'ETD',
  etd: 'ETD',
  ETA: 'ETA',
  eta: 'ETA',
  Embarque: 'Shipment',
  Chegada: 'Arrival',
  Originais: 'Originals',
  'Registro DI': 'DI Register',
  removerFiltros: 'Remove filters',
  filtrar: 'Filter',
  ate: ' until ',
  warningFiltro: 'Select a valid range and at least one category.',
  // MENU
  dashboard: 'Dashboard',
  tituloTooltipDashboard: 'Visualize the statistical data about the performance of import processes.',
  demandas: 'Supply',
  abrirProcessos: 'Open processes',
  novosProcessos: 'New processes',
  tituloTooltipNovosProcessos:
    'Start a new process and wait for its progress \nto the import stages. Edit the processes by double-clicking on the desired field.',
  inicieUmNovoProcesso: 'Start a new process and wait for its progress for the importation steps.',
  followUp: 'Follow-Up',
  inventario: 'Inventory',
  tituloTooltipEstoque:
    'It has the purpose of maintaining ideal inventory levels, \nin accordance with the goals and demands of the company.',
  armazem: 'Warehouse',
  financeiro: 'Financial',
  relatorios: 'Reports',
  tituloTooltipRelatorios:
    'Schedule the sending of reports to the email about \nyour process and stay on top of the updates that occur.',
  relatorio: 'Report',
  nomeRelatorio: 'Report Name',
  documentos: 'Documents',
  base: 'Base',
  usuarios: 'Users',
  tituloTooltipUsuarios: 'Register users to be able to share data.',
  selecione: 'Select',
  selecioneTipo: 'Select a user type',
  claro: 'Light',
  escuro: 'Dark',
  direitosReservados: 'All rights reserved',
  versao: 'Version',
  termosCondicoes: 'Terms and Conditions',
  politicasPrivacidade: 'Privacy Policy',
  // ROLES
  ADMINISTRADOR: 'ADMINISTRATOR',
  ANALISTA: 'ANALYST',
  CLIENTE: 'CLIENT',
  CLIENTE_GESTOR: 'MANAGER',
  'CLIENTE GESTOR': 'MANAGER',
  CLIENTE_CONSULTOR: 'CLIENT CONSULTANT',
  'CLIENTE CONSULTOR': 'CLIENT CONSULTANT',
  // MODAL EXPORTAR EM EXCEL
  tituloModalExportar: 'Export to excel file',
  planilhaBaixada: 'Excel file downloaded',
  descricaoModalExportar: 'Select the columns that you want to show.',
  disponiveis: 'Available',
  selecionadas: 'Selected',
  selecionarTodos: 'Select All',
  removerTodos: 'Unselect All',
  gerarArquivo: 'Create file',
  Referência: 'Reference',
  Processo: 'Process',
  'Status do Embarque': 'Shipment Status',
  'Unidade de Negócio': 'Business Unit',
  'Unidade de Medida': 'Measurement Unit',
  Quantidade: 'Quantity',
  Exportador: 'Exporter',
  Transportadora: 'Shipping company',
  Produto: 'Product',
  'Conhecimento de Embarque': 'Bill of lading',
  'Número DI': 'DI Number',
  'Canal DI': 'DI Channel',
  Desembaraço: 'Clearance',
  Faturamento: 'Invoicing',
  'Nº NF Entrada': 'Board invoice number',
  Containers: 'Containers',
  tituloTooltipContainers:
    'Essential to ensure the success of maritime cargo transport operations, \nproviding efficiency, safety, and quality to the import processes.',
  Container: 'Container',
  'Emissão NF Entrada': 'Board invoice emission',
  'Fechamento Operacional': 'Operational closure',
  'Exec. Carregamento': 'Load execution',
  'Licenças de Importação': 'Import licenses',
  'Armador/Agente de carga': 'Shipowner/Freight Agent',
  //COLUNAS KANBAN
  tituloTooltipKanban:
    'Visualize the import flow in a practical way. Click on the card for more details.',
  tooltipPreEmbarque: 'Proccess opening date until the shipment date',
  tooltipTransito: 'Shipment date until the ship arrival on port',
  tooltipDesembaraco: 'Ship arrival date until the DI release',
  tooltipCarregamento: 'DI release date until the load conclusion',
  tooltipFaturamento: 'Load conclusion date until the operational closure',
  preEmbarque: 'Pre-shipment',
  transito: 'In Transit',
  carregamento: 'Load',
  Carregamento: 'Load',
  carregamentoFaturamento: 'Loading/Billing',
  carrFaturamento: 'Load./Billing',
  solicitacao: 'Request',
  previsaoNaoInformada: 'Unknown departure forecast',
  dataCarregamento: 'Loading date',
  dataDoFaturamento: 'Billing date',
  dataFat: 'Invoice date',
  restam: 'Left',
  dias: 'days',
  dia: 'day',
  Dias: 'Days',
  atrasado: 'Overdue',
  emDesembaraco: 'In release: ',
  emCarregamento: 'In load: ',
  emFaturamento: 'In invoicing: ',
  emFechamento: 'In closure: ',
  diaChegada: 'Arrival expected day',
  registro: 'Register',
  nenhumItemFoi: 'No results',
  encontradoNaEtapa: 'found on',
  deFaturamento: 'invoicing stage.',
  deCarregamento: 'loading stage.',
  deDesembaraco: 'release stage.',
  deTransito: 'transit stage.',
  deEmbarque: 'pre-shipment stage.',
  Fechamento: 'Fechamento',
  'Em Trânsito': 'In Transit',
  'Em trânsito': 'In Transit',
  'Pré-Embarque': 'Pre-Boarding',
  // MODAL PROCESSO
  numeroContrato: 'Contract Number',
  taxaCambial: 'Exchange Rate',
  dataPagamento: 'Payment Date',
  valorReal: 'Value in BRL',
  variacaoCambial: 'Exchange variation',
  cambio: 'Exchange rate',
  tituloTooltipCambio: 'Follow the payment modalities, due dates and types of negotiations.',
  informacoes: 'Information',
  invoices: 'Invoices',
  contaCorrente: 'Checking account',
  maritima: 'Maritime',
  rodoviaria: 'Road',
  aerea: 'Aerial',
  embarque: 'Departure',
  informacoesGerais: 'General information',
  tipoProcesso: 'Process type',
  unidadeNegocio: 'Business unit',
  referenciaInterna: 'Internal reference',
  referenciaTrust: 'Trust Reference',
  referenciaCliente: 'Client Reference',
  'Referência Cliente': 'Client Reference',
  'Referência Trust': 'Trust Reference',
  cliente: 'Client',
  exportador: 'Exporter',
  produto: 'Product',
  invoice: 'Invoice',
  cidadeEmbarque: 'Shipment city',
  cidadeDestino: 'Destination city',
  'CONTA E ORDEM': 'ACCOUNT AND ORDER',
  'CONTA E ORDEM DE TERCEIROS': 'ACCOUNT AND ORDER',
  'CONTA PRÓPRIA': 'OWN ACCOUNT',
  'CONTA PROPRIA': 'OWN ACCOUNT',
  'IMPORTAÇÃO POR ENCOMENDA': 'IMPORT BY ORDER',
  transporteLogistica: 'Transport and Logistics',
  statusEmbarque: 'Shipment Status',
  modal: 'Modality',
  tipoCarga: 'Load type',
  incoterm: 'INCOTERM',
  incoterms: 'Incoterms',
  conhecimento: 'Bill of Lading',
  navioVeiculo: 'Vessel/Veichle',
  containers: 'Containers',
  container: 'Container',
  containerConsolidado: 'Consolidated container',
  devolucaoContainer: 'Container return',
  pesoBrutoKG: 'Gross Weight(KG)',
  pesoLiquidoKG: 'Net Weight(KG)',
  URFEntrada: 'URF Entrance/Arrival',
  freeTime: 'Free Time',
  freetime: 'Free Time',
  freteCollect: 'Freight collect',
  fretePrepaid: 'Freight prepaid',
  valorTotalFrete: 'Freight total cost',
  moedaFrete: 'Shipping currency',
  embalagemFrete: 'Packaging',
  quantidadeEmbalagem: 'Packaging Amount',
  datasPrevistas: 'Expected dates',
  previsaoEmbarque: 'Shipment forecast',
  previsaoChegada: 'Arrival forecast',
  datasConfirmadas: 'Confirmed dates',
  dataEmbarque: 'Shipment date',
  dataChegada: 'Arrival date',
  datasLiberacoes: 'Dates and releases',
  dataLiberacaoSiscarga: 'Siscarga release date',
  dataLiberacaoMapa: 'Map Release Date',
  liberacaoMinisterioAgricultadoPecuaria: 'MAPA Release Date',
  ultimaMovimentacao: 'Last entry',
  presencaCarga: 'Load presence',
  licencasImportação: 'Import licenses',
  tituloTooltipLI:
    'Follow the licenses required for importation, aiming at the regulation \nof international trade and protection of the national economy.',
  numLi: 'LI num.',
  orgaoAnuente: 'Consenting',
  dataRegistro: 'Registration date',
  dataStatus: 'Status date',
  dataValidade: 'Expiration date',
  statusLicenca: 'License Status',
  'Status L.I': 'License status',
  declaracaoImportacao: 'Import declaration',
  numeroRegistro: 'Registration number',
  dataDesembaraco: 'Release date',
  canalParametrizacao: 'Parametrization channel',
  parametrizacao: 'Parametrization',
  atualizacoes: 'Updates',
  ultimaAtualizacao: 'Last update',
  dataNaoInformada: 'Date not informed',
  baixarTodos: 'Download All',
  solicitacaoNumerario: 'Cash request',
  descricao: 'Description',
  dataSolicitacao: 'Request date',
  'Data de solicitação': 'Request date',
  acessar: 'Access',
  Acessar: 'Access',
  fechamentoProcesso: 'Process closure',
  visualizar: 'Visualize',
  Visualizar: 'Visualize',
  processo: 'Process',
  processoAberto: 'Your process has been successfully opened.',
  data: 'Date',
  formacaoValorAduaneiro: 'Formation of customs value',
  valorAduaneiroEstimado: 'Estimated customs value',
  composicao: 'Composition',
  moeda: 'Currency',
  Moeda: 'Currency',
  valorNegociado: 'Negotiated value',
  valorBRL: 'BRL value',
  impostos: 'Taxation',
  despesasNacionalizacao: 'Nationalization expenses',
  icmsIpiTransferencia: 'ICMS/IPI Transference',
  referencia: 'Reference',
  codigoProcesso: 'Processo code',
  'II - IMPOSTO DE IMPORTAÇAO': 'Import tax',
  naoInformado: 'Not informed',
  semAtualizacoes: 'No updates',
  as: 'at',
  semDocumentos: 'No documents available',
  solicitar: 'Request',
  documento: 'Document',
  dataEmissao: 'Emission date',
  numerario: 'Cash',
  total: 'Total',
  Total: 'Total',
  nenhumaInformacao: 'No results found',
  notasComplementares: 'Complementary invoices',
  notasFiscalEletronica: 'E-Invoice',
  valorNota: 'Invoice value',
  numeroNota: 'Invoice number',
  codigoDocumento: 'Document code',
  totalBruto: 'Gross weight total',
  totalLiquido: 'Net weight total',
  despesa: 'Expense',
  valorBruto: 'Gross value',
  valorLiquido: 'Net value',
  meioUtilizado: 'Used transport veichle',
  lclFcl: 'LCL (Consolidated/Loose Cargo), FCL (In container)',
  tipoBL: 'B/L number (Bill of Lading)',
  recintoDesembaraco: 'Customs clearance area',
  unidadeReceitaFederal: 'Federal revenue unit referring to the port of entry',
  VERDE: 'GREEN',
  AMARELO: 'YELLOW',
  VERMELHO: 'RED',
  CINZA: 'GRAY',
  invoicesProcesso: 'Process invoices',
  numeroInvoice: 'Invoice code',
  itensInvoice: 'Invoice items',
  item: 'Item',
  Item: 'Item',
  fabricante: 'Manufacturer',
  Fabricante: 'Manufacturer',
  NCM: 'NCM',
  quantidade: 'Quantity',
  condicaoPagamento: 'Payment terms',
  'Condição de pagamento': 'Payment terms',
  unidadeMedida: 'Measurement unit',
  'Unidade de medida': 'Measurement unit',
  valorUnitario: 'Unit value',
  'Valor Unitário': 'Unit value',
  totalCredito: 'Credit total',
  totalDebito: 'Debt total',
  diferenca: 'Difference',
  origem: 'Origin',
  Origem: 'Origin',
  evento: 'Event',
  Evento: 'Event',
  credito: 'Credit',
  Crédito: 'Credit',
  debito: 'Debt',
  Débito: 'Debt',
  vencimento: 'Due date',
  Vencimento: 'Due date',
  complemento: 'Complement',
  Complemento: 'Complement',
  mapa: 'Map',
  notaFiscalEntrada: 'Incoming invoice',
  ENCOMENDA: 'ORDER',
  PROPRIO: 'PRÓPRIO',
  PRÓPRIO: 'OWN',
  'ENCOMENDA PADRAO': 'DEFAULT ORDER',
  'ENCOMENDA PADRÃO': 'DEFAULT ORDER',
  'ENCOMENDA ESPECIAL': 'SPECIAL ORDER',
  'Nº da LI': 'LI Number',
  'Órgão anuente': 'Anuent organ',
  'Data de registro': ' Registration date',
  'Data de status': 'Status date',
  'Data de validade': 'Expiration date',
  'Status da licença': 'License status',
  'SEM PARAMETRO': 'WITHOUT PARAMETRO',
  //MAPA
  maritimo: 'Marine',
  rodoviario: 'Road',
  todos: 'All',
  abrirProcesso: 'New process',
  abrirProcessoNovaAba: 'Open a new tab to visualize the process',
  embarcacao: 'Ships',
  veiculos: 'Veichles',
  portos: 'Harbors',
  armazemTaglog: 'TRUST Warehouses',
  agrupamentos: 'Groups',
  trajetoPrevisto: 'Predicted path',
  trajetoPercorrido: 'Travaled path',
  cotacao: 'Price',
  dolar: 'Dollar',
  euro: 'Euro',
  especialistaComex: 'COMEX Specialist',
  email: 'E-mail',
  celularWhatsapp: 'WhatsApp',
  destino: 'Destination',
  navio: 'Ship',
  Navio: 'Ship',
  visualizarProcesso: 'View process',
  porto: 'Harbor',
  numeroPassagens: 'Total passages',
  CNPJ: 'DOC',
  localizacao: 'Address',
  naviosAgrupados: 'Grouped ships',
  portosAgrupados: 'Grouped harbors',
  clientesAgrupados: 'Grouped clients',
  viagensAgrupados: 'Grouped voyages',
  CTE: 'CTe num.',
  viagem: 'Travel',
  atualizadoEm: 'Updated at:',
  por: 'by',
  status: 'Status',
  remetente: 'Sender',
  destinatario: 'Recipient',
  destinatarios: 'Recipients',
  informacaodeCarga: 'Load information',
  valorCarga: 'Load value',
  valorCargaAverbada: 'Registered load value',
  valorPrestado: 'Provided value',
  valorRecebido: 'Received value',
  // MODAL SELECIONAR CLIENTES
  selecionarClientes: 'Select companies',
  // ABERTURA DE PROCESSO
  aberturaProcesso: 'Supply request',
  solicitarCancelamento: 'Request cancellation of the process',
  solicitarAlteracao: 'Request changes',
  alteracoesEncaminhadas: 'Your changes have been saved and will be forwarded to our specialists for review',
  jaPossuiAlteracao: 'This process already has a change request',
  solicitacaoAlteracaoPendente: 'You have a pending change request in this process',
  alteracoesFeitas: 'Changes made by the client',
  aceitarSolicitacaoPendente: 'Accept changes in the process',
  desejaAceitarAsAlteracoes: 'Do you want to accept the changes?',
  casoAceite: 'If you confirm, the data in this process will be altered',
  aguardandoAprovaoAlteracao: 'Awaiting approval for change',
  aguardandoCancelamento: 'Waiting for process cancellation',
  seVoceConfirmar: 'If you confirm this request, it will overwrite the request currently on hold',
  suaSolicitacaoDeCancelamento: 'Your cancellation request has been forwarded to our experts',
  processoAtualizado: 'Your process request has been updated',
  emCancelamento: 'In cancellation',
  exibirColunas: 'Show columns',
  'Tipo Importação': 'Import type',
  Finalidade: 'Subject',
  modelosProntos: 'Ready-made templates',
  Empresa: 'Company',
  'Solicitado em': 'Requested at',
  solicitadoPor: 'Requested by',
  responsavel: 'Responsible',
  Ações: 'Actions',
  responsaveisNaoVinculados: 'There are no representative contacts linked to your company',
  registrosPorPagina: 'Register per page',
  registros: 'Registers',
  resultados: 'Results',
  editar: 'Edit',
  editarItem: 'Edit item',
  remover: 'Remove',
  solicitarAbertura: 'Request supply',
  itens: 'Items',
  Itens: 'Items',
  observacao: 'Observation',
  anexarArquivos: 'Attach files',
  arquivosAnexados: 'Attached files',
  adicionarArquivos: 'Add file',
  salvar: 'Save',
  tipoDocumento: 'Document type',
  escolherArquivo: 'Choose file',
  unidadeComercializada: 'Commercialized unit of measure',
  carregando: 'Loading',
  tooltipMercosul:
    'Common names for Mercosul(Code which helps to identify products in Brazil, Argentina, Paraguai, Uruguai and other countries of Mercosul)',
  modificar: 'Modify',
  // LISTAGEM DE PROCESSOS
  cadastrarProduto: 'Insert product',
  editarProduto: 'Edit product',
  adicionarProduto: 'Add product',
  adicionadoProduto: 'Product added',
  produtoAdicionado: 'Product added! Register Product?',
  indice: 'Index',
  todosCamposObrigatorios: 'All fields are mandatory.',
  preenchaCamposObrigatorios: 'Please fill in all required fields',
  confirmarRemoverLista: 'Are you sure you want to remove this product from the list?',
  cadastroFuturo: 'You can register it again in the future.',
  editarReferencia: 'Edit reference',
  codigoCliente: 'Client code',
  grupo: 'Group',
  fornecedor: 'Provider',
  produtor: 'Producer',
  produtorFabricante: 'Producer / Manufacturer',
  Fornecedor: 'Supplier',
  Produtor: 'Producer',
  codigoTrust: 'Trust code',
  textoNCM:
    'When registering, you will be able to use this same product in other operations, when entering the NCM.',
  cadastrar: 'Register',
  Importador: 'Importer',
  // LISTAGEM DE PROCESSOS
  listagemProcessos: 'Process list',
  processosAfiliados: 'Affiliates Follow-Up',
  tituloTooltipListagemProcessos:
    'All processes in list, being able to filter \nand save in models to facilitate use.',
  modeloRelatorios: 'Report models',
  relatorioSalvo: 'Report saved sucessfully',
  relatorioAtualizado: 'Report updated sucessfully',
  relatorioSemDescricao: 'A report cannot be saved without a description',
  criarModeloRelatorio: 'Create new report model',
  alterarModeloRelatorio: 'Update report model',
  digiteAqui: 'Type here',
  digiteAquiNCM: 'Search here for NCM',
  selecioneColunas: 'Select columns which you want to show on list',
  criarRelatorio: 'Create report',
  atualizarRelatorio: 'Update report',
  relatorioAplicado: 'Report applied',
  listagem: 'List',
  deferimentoLi: 'LI approval',
  // INVENTARIO
  de: 'of',
  fraseEstoqueMiniRefpart1: 'Inglês: The reference value is the current stock. This means that if the checkbox is marked, the minimum stock will be',
  fraseEstoqueMiniRefpart2: '% available current stock',
  estoqueMinimoMensagemPorcentagemAviso: 'When selecting stock by percentage, it should be between 1 and 200.',
  valorPorPercentagemEstoque: 'Minimum inventory percentage (%) of current',
  'Código do produto': 'Product code',
  'Nome do Produto': 'Product name',
  'Categoria do NCM': 'NCM category',
  'Previsão no armazém': 'Warehouse forecast',
  estabelecimento: 'Establishment',
  descricaoGrupo: 'Group description',
  quantidadeAtual: 'Current amount',
  situacao: 'Situation',
  descricaoEndereco: 'Address description',
  inventarioDescricao: 'Inventory for the previous day',
  descricaoProduto: 'Product description',
  depositante: 'Depositor',
  tipoUnidade: 'Unit type',
  classe: 'Class',
  quantidadeEmpenhado: 'Pledged Quantity',
  quantidadeReserva: 'Reserve quantity',
  armazenadoEm: 'Stored in',
  quantidadeProdutosEmTransito: 'Quantity of products in transit',
  quantidadeProdutosAtual: 'Current quantity of products',
  // ARMAZEM
  // RELATORIOS
  adicionar: 'Add',
  Habilitado: 'Available',
  Descrição: 'Description',
  desabilitado: 'Unavailable',
  'Dias da Semana': 'Days of week',
  Horário: 'Time',
  'E-mails': 'E-mails',
  adicionarRelatorio: 'Add report',
  editarRelatorio: 'Update report',
  conteudoRelatorio: 'Report content',
  escolhaColunasFiltros: 'Choose the columns or select a favorite filter',
  escolhaColunasFiltrosIntro1: 'You can bookmark a filter with the column options you prefer.',
  escolhaColunasFiltrosIntro2: 'This feature is also available in the process listing, allowing you to filter the process visualization according to your needs.',
  habilitarAgendamento: 'Turn on schdeule',
  cancelar: 'Cancel',
  naoCancelar: "Don't cancel",
  excluirAgendamento: 'Remove report schedule?',
  naoRecuperavel: "If you confirm, it's not possible recover that item.",
  excluirAberturaProcesso: 'Remove supply order?',
  nossosEspecialistasVao:
    'Our specialists will receive your request and we will return to you by email with the adjustments',
  recuperavel: 'You are able to recover after remove.',
  excluido: 'Delete success',
  voltarAgendamentos: 'Returning to reports list',
  tenteNovamente: 'Please, try again.',
  confirmar: 'Confirm',
  'Un. de Negócio': 'Business unit',
  'Un. de Medida': 'Measurement unit',
  // INCENTIVO FISCAL
  incentivoFiscal: 'Tax Incentive',
  icmsPago: 'ICMS Paid',
  aliquotaIcmsPago: 'ICMS Rate Paid',
  formaDesconto: 'Discount Method',
  descontoIcmsPago: 'ICMS Discount Paid',
  pctCliente: '% BC Customer',
  pctGanhoLiquido: '% Net Gain',
  valorCliente: 'Customer Value',
  porcentagemCliente: '% Customer',
  pctEmpresa: '% Company',
  // GED
  ged: 'Eletronic Documents Management',
  baixarSelecionados: 'Download selected',
  visualizarSelecionados: 'View selected',
  Documento: 'Document',
  Tipo: 'Type',
  Extensão: 'Extension',
  arquivoNaoSuportado: 'The file must have the extension xlsx, xls or csv',
  Data: 'Date',
  // USUARIOS
  Foto: 'Photo',
  Código: 'Code',
  'Criado em': 'Created at',
  'Nome completo': 'Full name',
  Email: 'E-mail',
  senha: 'Password',
  confirmarSenha: 'Confirm password',
  criarSenha: 'Create password',
  caracteresSenha: '8 to 25 characters',
  maiusculas: 'At least one capital letter',
  letrasNumeros: 'Numbers and Letters',
  caractereEspecial: "Special characteres ! @ # $ % & * ' _ + = [ ] { } | : . ? ~ ( ) ; ,",
  adicionarUsuario: 'Add User',
  editarUsuario: 'Edit user',
  CNPJContatos: 'Representative contacts & DOC',
  notificacoes: 'Notifications',
  fotoPerfil: 'Profile picture',
  opcional: 'Optional',
  empresas: 'Companies',
  empresa: 'Company',
  tituloTooltipEmpresas: 'View the DNA and the people in charge of the registered companies.',
  nomeEmpresa: 'Company name',
  tipoUsuario: 'User type',
  responsavelComercial: 'Commecial representative',
  nome: 'Name',
  responsavelOperacional: 'Operational manager',
  clientesCNPJ: 'Linked DOCs',
  consultarCNPJ: 'Link CNPJ',
  'Cód. Conexos': 'Conexos code',
  Nome: 'Name',
  Cidade: 'City',
  UF: 'State',
  'Razão Social': 'Corporate name',
  adicionarSelecionados: 'Add selected',
  receberNotificacoes: 'Receive notifications',
  notificacoesWhatsapp: 'WhatsApp notifications',
  tipoNotificacao: 'Notification types',
  // DASHBOARD
  bemVindo: 'Welcome',
  tempoLiberacao: 'Release time (days)',
  tempoLiberacaoProduto: 'Release time by product (days)',
  top10Produtos: 'Top 10 products',
  acertoNumerario: 'Cash hits (%)',
  tempoMedioFechamento: 'Average closure time (days)',
  processos: 'Processes',
  statusProcesso: 'Process status (%)',
  faturamento: 'Invoicing',
  emTempo: 'On time',
  verde: 'Green',
  vermelho: 'Red',
  amarelo: 'Yellow',
  cinza: 'Gray',
  Janeiro: 'January',
  Fevereiro: 'February',
  Março: 'March',
  Abril: 'April',
  Maio: 'May',
  Junho: 'June',
  Julho: 'July',
  Agosto: 'August',
  Setembro: 'September',
  Outubro: 'October',
  Novembro: 'November',
  Dezembro: 'December',
  janeiro: 'January',
  fevereiro: 'February',
  marco: 'March',
  abril: 'April',
  maio: 'May',
  junho: 'June',
  julho: 'July',
  agosto: 'August',
  setembro: 'September',
  outubro: 'October',
  novembro: 'November',
  dezembro: 'December',
  // FINANCEIRO
  modalidade: 'Mode',
  porcentagem: 'Percentage',
  tipoVencimento: 'Due type',
  dataVencimento: 'Due date',
  valor: 'Total cost',
  undefined: 'Object not found',
  // MENSAGEIRO
  mensageiro: 'Postman',
  tituloTooltipMensageiro:
    'Schedule the sending of reports to the email about \nyour process and stay on top of the updates that occur.',
  Responsável: 'Responsible',
  'Última execução': 'Sent last time',
  excluirAgendamentoPadrao: 'Remove schedule?',
  excluirProduto: 'Delete product?',
  enviarEmail: 'Send e-mail now',
  agendamento: 'Scheduler',
  agendar: 'Schedule',
  erroSalvarAgendamentoMensageiro: 'Something went wrong, could not save the schedule!',
  preenchaTodoAgendamento: 'Please fill out all fields.',
  agendamentoSalvoComSucesso: 'The schedule has been saved',
  redirecionamentoTelaListagem: 'You will be redirect the listing screen.',
  Copiar: 'Copy',
  Reenviar: 'Resend',
  enviar: 'Send',
  enviarEmailAgora: 'Send the e-mail now?',
  sucessoEnvioEmail: 'E-mail sended successfully!',
  processoCompartilhadoSucesso: 'The Processes was successfully shared!',
  adiantado: 'In advance',
  obrigatorio: 'Required.',
  emailInvalido: 'The email address entered appears to be incorrect. Please check and try again',
  cnpjInvalido: 'Invalid DOC.',
  senhaInvalida: "The password doensn't fit the requirements",
  senhasDiferentes: 'Passwords do not match',
  // notificações
  chegada: 'Arrival',
  ativarNotificacoes: 'Enable all notifications',
  embarquePrevisto: 'Scheduled shipment',
  embarqueEfetivo: 'Effective shipment',
  manifestoCarga: 'Cargo manifest',
  emailDestino: 'Subject e-mails',
  empresaSelecionadaNaoExiste: 'The selected company is not registered',
  cadastroEmpresa: 'Company register',
  cadastroUsuario: 'User register',
  emailEnviado: 'E-Mail sent succesfully',
  vincularEmpresa: 'Bind companies',
  frequencia: 'Frequency',
  campos: 'Fields',
  transitTime: 'Transit time',
  tituloTooltipTransitTime:
    'View the progress of the process \nbetween the stages and the estimated time to be completed.',
  ano: 'Year',
  dom: 'Sun',
  seg: 'Mon',
  ter: 'Thu',
  qua: 'Wed',
  qui: 'Tue',
  sex: 'Fri',
  sab: 'Sat',
  DI: 'DI',
  siscarga: 'Siscarga',

  // Tour
  tourCancelar: 'Cancel',
  tourVoltar: 'Back',
  tourProximo: 'Next',
  tourFinalizar: 'Finish',

  tourBemVindo: 'Welcome!',
  tourBemVindoMensagem: 'We will show you our main features, it will be quick.',

  tourMapa: 'Map',
  tourMapaMensagem: 'TTrack maritime and road cargo shipments, as well as ports, warehouses, and manufacturers.',

  tourDashboard: 'Dashboard',
  tourDashboardMensagem: 'View charts and statistics of your processes, products, cash flow, and other information.',

  tourFollowUp: 'Follow-Up',
  tourFollowUpMensagem: 'Track your process through the import stages.',

  tourMenu: 'Menu',
  tourMenuMensagem: 'Expandable menu that provides access to other available modules in the system.',

  tourProcessos: 'Open Processes',
  tourProcessosMensagem: 'Open processes and wait for their progress.',

  tourGestaoLi: 'LI Management',
  tourGestaoLiMensagem: 'Check the licenses required for importation.',

  tourDocumentos: 'Documents',
  tourDocumentosMensagem: 'Review documents related to your processes.',

  tourAgendarRelatorios: 'Schedule Reports',
  tourAgendarRelatoriosMensagem: 'Schedule customized reports to receive via email.',

  tourUsuarios: 'Users',
  tourUsuariosMensagem: 'Add and configure users to use the system with you.',

  tourSelecaoEmpresas: 'Company Selection',
  tourSelecaoEmpresasMensagem: 'Filter the companies you want to view using the CNPJ.',

  tourChat: 'Chat',
  tourChatMensagem: 'Ask questions and exchange information with our AI or with the experts.',

  tourTema: 'Themes',
  tourTemaMensagem: 'Switch between light and dark theme.',

  tourNotificacoes: 'Notifications',
  tourNotificacoesMensagem: 'Check updates on processes and configure email notifications.',

  tourPerfil: 'Profile',
  tourPerfilMensagem: 'Edit your data, take a look at the news on our platform, review the tour again, or switch access accounts.',

  tourMapaFuncionalidade: 'Map Options',
  tourMapaFuncionalidadeMensagem: 'You can center, zoom in, and zoom out on the map.',

  tourMapaFiltros: 'Map Filters',
  tourMapaFiltrosMensagem: 'Option to filter processes based on their status.',

  tourObrigado: 'Thank you for your attention',
  tourObrigadoMensagem: 'If you still have questions, please contact our team.',

  removerDemanda: 'Do you want to delete this supply?',
  possivelRecuperar: 'Is it possible to recover after deletion.',
  proximo: 'Next',
  itemAdicionado: 'Item added! Register item?',
  disponivelNCM:
    'The item will be registered in our database and you will be able to reuse this item in future operations.',
  fechar: 'Close',
  preenchaTudo: 'Fill in all fields before registering an item.',
  produtoSalvo: 'Product registered successfully!',
  produtoJaCadastrado: 'The product is already registered',
  produtoDeletado: 'Product deleted successfully!',
  ncmAutomatico:
    'Enter the NCM code, if it is in our database, the information will be filled in automatically, partially or completely.',
  configuracoes: 'Settings',
  statusAlterado: 'Status has changed',
  hoje: 'Today',
  ontem: 'Yesterday',
  estaSemana: 'This week',
  semanaPassada: 'Last week',
  esteMes: 'This month',
  anteriores: 'Previous',
  assimQueAtualizar: 'As soon as updated',
  diariamente: 'Daily',
  semanalmente: 'Weekly',
  desabilitarEnvio: 'Disable send',
  dataRegistroDI: 'DI record',
  numeroProtocoloDI: 'DI protocol number',
  dataDesembaracoDI: 'DI clearance',
  dataAbertura: 'Opening',
  dataFechamentoOperacional: 'Operational closing',
  dataExecucaoCarregamento: 'Loading execution',
  carregamentoAgendado: 'Scheduled upload',
  dataFaturamento: 'Billing',
  dataEnvioFaturamento: 'Billing submission',
  emissaoNotaEntrada: 'Issuance of invoice',
  dataPresencaCarga: 'Load presence',
  conhecimentoEmbarque: 'Bill of lading',
  dataVistoriaMapa: 'MAPA inspection',
  dataRecebimentoOriginais: 'Receipt of Documents',
  cadastrarUsuario: 'Add user',
  listarUsuario: 'List users',
  legenda: 'Info box',
  refazerTour: 'Re-do tour',
  sairConta: 'Are you sure you want logout?',
  zoomIn: 'Zoom In',
  zoomOut: 'Zoom Out',
  centralizarMapa: 'Re-center',
  registroNaoEncontrado: 'Item not found, try another',
  processoNaoPossuiLocalizacaoMapa: 'The item does not have geo location registered',
  avisoCamposObrigatorios: 'Fields marked with * must be fufilled.',
  maisDetalhes: 'More details',
  codigoProduto: 'Product code',
  lote: 'Batch',
  loteFabricacao: 'Manufacturing lot',
  dataFabricacao: 'Manufacturing date',
  codigoPallet: 'Pallet code',
  codigoSequenciaLote: 'Batch sequency code',
  dataMovimentacao: 'Move date',
  numeroLote: 'Batch number',
  numeroLoteFabricacao: 'Manufacturing batch number',
  quantidadeBloqueada: 'Amount blocked',
  quantidadeEmpenhada: 'Pledged amount',
  carregarTemplate: 'Load template',
  importarModelo: 'Import model data',
  baixarModelo: 'Download template',
  solteArquivos: 'Drag and drop your files here.',
  arquivosPermitidos: 'Allowed files: XLSX, DOC and PDF.',
  solteCarregar: 'Drop files here to upload.',
  carregandoArquivos: 'Loading files...',
  verifiqueAntesSalvar: 'Check fields before saving.',
  processoExiste: 'This reference number already exists, please check.',
  valorTotal: 'Total value',
  codigoNCM: 'NCM code',
  descricaoDetalhada: 'Detailed description',
  produtos: 'Products',
  tituloTooltipProdutos:
    'Register products to import them into your processes and have a history of everything.',
  // MENSAGENS DE VALIDACOES CADASTRO DE PRODUTOS
  valorUnitarioPositivo: 'The unit value must be greater than zero',
  quantidadePositivo: 'The quantity field must be greater than zero',
  preenchaCampoProdutor: 'Producer field is empty, please fill in',
  preenchaCampoFornecedor: 'Supplier field is empty, please fill in',
  preenchaCampoCodigoCliente: 'The customer code field is empty, please fill it in',
  preenchaCampoProduto: 'The product field is empty, please fill it in',
  preenchaCampoUnidadeMedida: 'The unit of measure field is empty, please fill it in',
  preenchaCampoNCM: 'The NCM code field is empty, please fill it in',
  preenchaCampoMoeda: 'Currency field is empty, please select one of the currencies',
  preenchaCampoEmpresa: 'The company field is empty, please select one of the companies',
  maximo10characteres: 'Thie field must be at most 10 characteres',
  maximo20characteres: 'Thie field must be at most 20 characteres',
  maximo100characteres: 'Thie field must be at most 100 characteres',
  excluirUsuario: 'Delete user?',
  //////////////////////////////// ERROS
  ERRO_INTERNO_SERVIDOR_LOGIN:
    "We're sorry, but an internal error occurred on our server when trying to log in. We're working to fix the issue and apologize for the inconvenience. Please try again in a few minutes or contact our technical support team for assistance. Thank you for your understanding.",
  actions: 'Actions',
  ncm: 'NCM Code',
  //TAREFAS
  pendente: 'Pending',
  administrativo: 'Administrative',
  aguardando: 'Waiting',
  regulatorio: 'Regulatory',
  novoProduto: 'New product',
  cadastroNovoProduto: 'New product',
  regulatorioCadastroNovoProduto: 'New product / regulatory',
  REGULATORIOCADASTRONOVOPRODUTO: 'New product / regulatory',
  cadastros: 'Records',
  cancelamentos: 'Cancellations',
  acompanhamento: 'Follow-up',
  liberacao: 'Release',
  nacionalizacao: 'Nationalization',
  gestaoTarefas: 'Task management',
  id: 'ID',
  licenciamento: 'Licensing',
  validacaoRegulatorio: 'Regulatory validation',
  historico: 'History',
  processoMovido: 'Process moved to',
  comentar: 'Comment',
  reenviarAcesso: 'Do you want to send an email with a new access? The current password will be changed.',
  tarefas: 'Tasks',
  tarefasProcessoPendente: 'Pending process',
  tarefasTratamentoAdministrativo: 'Administrative treatment',
  tarefaRegulatorioCadastroNovoProduto: 'New product / regulatory',
  tarefasAcompanhamento: 'Post-shipment follow-up',
  tarefasLiberacao: 'Release',
  tarefasNacionalizacao: 'Nationalization',
  tarefasFechamento: 'Closure',
  cardJaEstaEmAnaliseProduto: 'This card has already been created in the New product / Regulatory stage',
  atividades: 'Activities',
  atribuirMim: 'Assign to me',
  proximaEtapa: 'Next stage',
  sim: 'Yes',
  nao: 'No',
  conferido: 'Checked',
  filtrosFavoritos: 'Favorite filters',
  vincularFiltroModelo: 'Do you want to link the last search/filter to this model?',
  salvarUmFiltro: 'Save a filter',
  criarUmNovoFiltro: 'Create a favorite filter',
  editarFiltro: 'Edit filter',
  filtroSalvo: 'Filter saved successfully',
  filtroAtualizado: 'Filter updated',
  fltroAplicado: 'Filter applied',
  envioDocumentosFechamento: 'Document submission',
  editarObservacao: 'Edit observation',
  regulatoriocadastronovoproduto: 'regulatory and new product registration',
  concluidos: 'Completed',
  esconderColunaConcluidos: 'Hide completed column',
  exibirColunaConcluidos: 'Show completed column',
  // USUARIOS
  usuarioRemovido: 'User deleted successfully',
  acessoEnviado: "Access has been sent to user's email",
  excluirProprioUsuario: 'You cannot delete your own user!',
  naoPodeReenviar: 'You cannot resend your own email and first access!',
  usuarioAtualizado: 'User updated successfully!',
  usuarioInserido:
    'User inserted successfully! Please wait for the password to be generated and sent to your email',
  naoRecuperouUsuario: 'Could not retrieve user data!',
  formatoInvalido: 'The field format is invalid!',
  nomeLetras: 'Name must contain at least 3 letters!',
  nomeMaxLetras: 'Name must contain a maximum of 50 letters!',
  campoObrigatorio: 'This field is mandatory!',
  emailFormato: 'Invalid email format.',
  emailMaxLetras: 'The email field must contain a maximum of 80 letters!',
  especifiqueUsuario: 'Specify the user type',
  senhaLetras: 'Password must contain at least 8 characters.',
  senhaMaxLetras: 'Password must contain a maximum of 25 characters.',
  senhaDiferentes: 'Passwords are not the same.',
  historicoCompleto: 'Complete history mode',
  descricaoHistorico:
    '<p>The historical model includes in each update email <span style:"text-decoration: underline">all the stages</span> covered by the process with dates and context. You can activate the button and receive it in this format.</p> <p>If you leave it disabled, the content of the email will only be the latest update.</p>',
  limpar: 'Reset',
  ativo: 'Activate',
  desativado: 'Disabled',
  naoDigiteUnidadeMedida: 'Do not enter the unit of measure',
  avisoViaEmail: 'Receive a notification via email?',
  emailsDestinos: 'Destination emails',
  estoque: 'Stock',
  estoqueDisponivel: 'Available stock',
  estoqueLimite: 'Stock running low or out',
  receberAvisoEstoqueText: 'Indicate in the table when the stock is *',
  estoqueMinimoAtualizadoSucesso: 'Minimum stock has been updated successfully.',
  minimoEstoqueDesejado: 'Desired minimum stock',
  naoDefinido: 'Not defined',
  legendaSemConfiguracaoEstoqueMinimo: 'Configuration not defined',
  legendaEmailDesativadoErroEstoqueMinimo: 'Stock below the minimum and e-mail disabled',
  legendaEmailDesativadoEstoqueMinimo: 'Stock avaliable and e-mail disabled',
  legendaEstoqueMinimoAlerta: 'Stock is below the defined minimum',
  legendaEstoqueMinimoErro: 'Stock is sold out',
  legendaEstoqueMinimoIdeal: 'Stock avaliable',
  formatoCampoEmailInvalido: 'Email format invalid',
  requiredFieldValorEstoqueMinimo: 'Field Minimum Stock empty',
  requiredFieldTypeErrorNumber: 'The field minimum stock has to be a number',
  requiredFieldEmail: 'The field Email is empty, please insert at least one valid e-mail',
  // AG-GRID
  equals: 'Equals',
  notEqual: 'Not equal',
  blank: 'Blank',
  notBlank: 'Not blank',
  contains: 'Contains',
  notContains: 'Not contains',
  startsWith: 'Starts with',
  endsWith: 'Ends with',
  filter: 'filter',
  andCondition: 'AND',
  orCondition: 'OR',
  busqueCNPJ: 'Search for companies by name or CNPJ.',
  removerEmpresas: 'Remove companies',
  aplicar: 'Apply',
  cliqueCardDetalhes: 'Click on the card for more details',
  fechamento: 'Closure',
  pending: 'Pending',
  in_transit: 'In transit',
  occurrence_treatment: 'Occurrence treatment',
  done: 'Done',
  motorista: 'Driver',
  placa: 'Plate',
  valorNF: 'Invoice value',
  pesoRealNF: 'Invoice actual weight',
  tituloEstoqueMinimo: 'Minimum Stock',
  buscaAvancada: 'Advanced search',
  codProcesso: 'Process Code',
  paisOrigem: 'Origin country',
  paisDestino: 'Destination country',
  placaRodoviario: 'Plate (Road)',
  dataEntregaContainer: 'Container delivery date',
  removerSelecionados: 'Remove selected',
  marcarDesmarcarTodos: 'Check / Uncheck all',
  // Tarefas atividades novoProduto
  recebimentoDescricao: 'Receiving description / NCM / Supplier data',
  formularioCadastroProduto: 'Form for registering products',
  formularioCadastroFornecedores: 'Form for registering suppliers',
  aberturaChamadoCadastro: 'Opening of registration call',
  produtoCadastrado: 'Registered product',
  // Tarefas atividade regulatório
  envioFormularioRegulatorio: 'Sending form to regulatory department',
  envioDocumentos: 'Sending documents / MSDS / FISPIQ',
  pendenciaDocumental: 'Documentary / information pending',
  analiseRegulatorioLiberado: 'Regulatory analysis released',
  // Tarefas atividade acompanhamento
  cadastroConhecimentoConexos: 'Registration of bill of lading in Conexos',
  emissaoLiPosEmbarque: 'Post-shipment LI issuance',
  documentosOriginais: 'Original documents',
  telex: 'Telex',
  conferenciaCeMercante: 'Merchant CE Conference',
  envioNumerario: 'Cash dispatch',
  digitacaoDI: 'DI typing',
  lancamentoMapaMadeira: 'Madeira Map Entry',
  verificacaoValorConta: 'Account value verification',
  autorizacaoRegistroDI: 'DI/AFRMM registration authorization',
  // Tarefas atividades liberacao
  envioDiRegistrada: 'Sending of registered DI',
  envioCI: 'Sending of CI',
  pagamentoTaxaBL: 'Payment of BL/Freight fees',
  envioDocumentacaoLiberacaoBL: 'Sending of BL release documentation',
  desbloqueioSiscarga: 'Siscarga unblocking',
  solicitarExoneracaoICMS: 'Request ICMS exoneration',
  montarNF: 'Invoice assembling / Checking expenses for invoice',
  liberacaoComex: 'Comex release',
  recebimentoNfTrust: 'Receipt of NF Trust',
  programacaoCarregamento: 'Client and transport loading scheduling',
  liberacaoFaturamentoTerminal: 'Terminal billing release',
  agendamentoRetirada: 'Pickup scheduling',
  minutaDevolucaoCNTR: 'CNTR return draft',
  lavacaoAvaria: 'Cleaning / Damage',
  demurrage: 'Demurrage',
  envioFechamento: 'Sending for closing',
  // Tarefas atividades fechamento
  recebimento: 'Receipt',
  verificacaoRazaoProcesso: 'Process reason verification',
  envioFechamentoCliente: 'Sending closure to client',
  gestaoLicencasImportacao: 'Import License Management',
  gestaoLI: 'I.L. Management',
  licencaImportacao: 'Import License',
  visualizeLI:
    'Track the necessary licenses for import, aiming for international trade regulation and national economy protection.',
  dataSituacao: 'Status Date',
  li: 'IL',
  dataReg: 'Registration Date',
  validadeSituacao: 'Status Validity',
  dataProtocolo: 'Protocol Date',
  anuencia: 'Consent',
  paraAnalise: 'To Analysis',
  emExigencia: 'In Demand',
  deferida: 'Approved',
  encaminhar: 'Send',
  encaminharProcessoEmail: 'Send process by email',
  verMais: 'See more',
  verMenos: 'See less',
  dataTransbordo: 'Transfer',
  dataTransbordo2: 'Second transfer',
  sequencia: 'Sequence',
  ultimoAcesso: 'Last access',
  cliqueAdicionarProduto: 'Click to add new product',
  house: 'BL House',
  master: 'BL Master',
  tipoContainer: 'Container Type',
  armador: 'Shipping Line',
  lacre: 'Seal',
  dataChegadaContainer: 'Container Arrival',
  vencimentoFreetime: 'Freetime Expiration',
  situacaoEvento: 'Event status',
  containerDevolvido: 'Container returned',
  dataEvento: 'Event date',
  situacaoEventoArmador: 'Shipping line event status',
  nomeNavio: 'Vessel name',
  localEvento: 'Event location',
  identificacaoViagem: 'Voyage identification',
  dataViagem: 'Voyage date',
  Modalidade: 'Mode',
  Porcentagem: 'Percentage',
  Valor: 'Value',
  Invoice: 'Invoice',
  'Tipo vencimento': 'Due Date Type',
  statusDoProcesso: 'Process status',
  reenviarEmailProcesso: 'Resend process e-mail',
  erroAoEnviarEmail: 'There was an error sending the email',
  aperteEnterParaCadaEmail: 'Hit the enter key for each email address entered',
  tipoDeImportacao: 'Import type',
  cliqueParaBaixar: 'Click for download',
  Abertos: "Open",
  Encerrados: "Closed",
  extratoLI: 'License statement',
  // ged
  documentoBaixadoSucesso: 'Document downloaded successfully',
  erroBaixarDocumento: 'An error occurred while downloading the document',
  erroVisualizarDocumento: 'An error occurred while viewing the document',
  // gestao containers
  containersNaoEncontrados: 'Containers not found for this type of filter.',
  //Produtos Processos
  'PET - RESINA': 'PET - RESIN',
  'PVC - RESINA': 'PVC - RESIN',
  'PROPRIO DIVERSOS': 'OWN VARIOUS',
  'SUPLEMENTOS': 'SUPPLEMENTS',
  // GRÁFICOS
  indicadores: 'Indicators',
  licencasDeferidas: 'Licenses granted',
  licencasComExigencia: 'Licenses with requirements',
  licencasSemExigencia: 'Licenses without requirements',
  tempoAberturaDeferimento: 'Time from opening to approval (days)',
  expectativaChegada: 'Arrival prediction',
  codCalculo: "Calculation Code Revenue/Cost",
  estadoCalculo: "Calculation Status Revenue/Cost",
  dataInicio: "Start Date",
  dataFim: "End Date",
  valorServico: "Service Value",
  valorCalculado: "Calculated Value",
  ordemCompra: 'Purchase order',
  aVista: 'In cash',
  aPrazo: 'On installments',
  termosPagamento: 'Payment Terms',
  portoOrigem: 'Port of origin',
  portoDestino: 'Destination port',
  enderecoExportador: 'Exporter address',
  selecionarCNPJ: 'Select and add DOCs to the user',
  vincular: 'Link',
  manutencoes: 'Maintenance',
  // TabName
  'Login': 'Login',
  'Home': 'Home',
  'AberturaProcesso': 'New processes',
  'ProcessosKanban': 'Follow-Up',
  'GestaoLI': 'IL Management',
  'ListagemProcesso': 'Process List',
  'TransitTime': 'Transit Time',
  'Estoque': 'Stock',
  'Financeiro': 'Financial',
  'AgendamentoRelatorios': 'Reports',
  'Ged': 'Electronic Document Management',
  'Mensageiro': 'Postman',
  'Tarefas': 'Task Management',
  'ListarUsuarios': 'Users',
  'Produtos': 'Products',
  'Dashboard': 'Dashboard',
  'Empresas': 'Companies',
  'Manutencao': 'Maintenance',
  'RecuperarSenha': 'Forgot Password',
  'processosParceiros': 'Partners',
  'processosComissao': ' Partners',
  bugs: 'Bugs: ',
  melhorias: 'Improvements: ',
  manutencao: 'Maintenance: ',
  novidades: 'News: ',
  patchNotes: 'Patch Notes',
  assistente: 'Assistant',
  assistente1: 'Assistant 1',
  assistente2: 'Assistant 2',
  assistentes: 'Assistants',
  introPatchNotes1: 'These are just some of the improvements and features introduced in each version of Trinity. We are always committed to enhancing the platform and providing you with the best possible experience.',
  introPatchNotes2: 'We will be sharing information about upcoming releases and exciting features that are on the way.',
  manutecoes: 'Maintenances',
  acoes: 'Actions',
  aguardandoAtualizacao: 'Waiting for update',
  copiarLinkProcesso: 'Copy process link',
  estrategico: 'Strategic',
  chat: 'Chat',
  entendi: 'Got it',
  aindaNaoembarcado: 'Not yet shipped',
  seuProcessoAindaNaoEmbarcado: 'Your process has not yet been shipped.',
  fiqueOlho: 'Keep an eye in the coming days.',
  ops: 'Oops',
  processoNaoEncontrado: 'This process was not found.',
  naoRegistrado: 'Your ship may be in an area without radar or may not have been registered.',
  transporteAereo: 'Air transport',
  seuProcessoAereo: 'Your process is in the air transport mode.',
  naoApareceMapa: 'This mode does not currently appear on the map.',
  transitoConcluido: 'Transit completed',
  processoNaoTransito: 'Your process is no longer in transit.',
  cliqueDetalhesProcesso: 'Click to view the details of this process.',
  verDetalhes: 'View details',
  // CRC
  crcMenu: 'WH Costs',
  crc: 'Warehouse Costs',
  codigoCRC: 'Revenue/Cost Calculation Code',
  estadoCRC: 'Revenue/Cost Calculation State',
  descricaoServico: 'Service Description',
  quantidadeServico: 'Service Quantity',
  editarEmpresa: 'Edit company',
  // Cadastro basico
  cadastroBasico: 'Basic Records',
  fornecedorProdutor: 'Supplier / Producer',
  siglaSimbolo: 'Abbreviation/Symbol',
  Cadastro: 'Record',
  salvoComSucesso: 'successfully saved',
  deletadoComSucesso: 'was successfully deleted',
  sigla: 'Abbreviation',
  tipo: 'Type',
  alta: 'High',
  media: 'Medium',
  baixa: 'Low',
  prioridade: 'Priority',
  // DNA Empresas
  sequencial: 'Sequential',
  questionario: 'Questionnaire',
  questionarios: 'Questionnaires',
  perguntas: 'Questions',
  respostas: 'Answers',
  perguntasAndRespostas: 'Questions and Answers',
  responsavelComex: 'Comex Manager',
  assistenteComex: 'Comex Assistant',
  responsavelExecutivo: 'Executive Manager',
  //
  totalProcessosDescricao: 'Ongoing processes by status',
  statusProcessosDescricao: 'In relation to the original shipping forecast',
  canalParametrizacaoDescricao: 'In relation to ongoing processes',
  topProdutosDescricao: 'In relation to the number of invoices',
  acertoNumerarioDescricao: 'In relation between Estimated value vs Realized value',
  tempoLiberacaoFechamentoDescricao: "In relation to the cargo's presence date",
  //
  placeholderFornecedorProdutorInputNome: 'Example Company Ltd.',
  placeholderFornecedorProdutorInputCNPJ: '00.000.000/0001-00',
  placeholderMoedaInputSiglaSimbolo: 'USD',
  placeholderMoedaInputDescricao: 'US Dollar',
  placeholderUnidadeMedidaInputSiglaSimbolo: 'KG',
  placeholderUnidadeMedidaInputDescricao: 'Kilograms',
  recuperarRascunho: 'Restore draft',
  messageAddInformacaoCadastroBasico: "If you wish to add a new item, please contact an administrator.",
  mensagemCampoDescricaoCadastroBasico: 'The description field must contain at least 5 characters.',
  mensagemCampoSiglaMoeda: 'The abbreviation field must contain at least 3 characters.',
  mensagemCampoSiglaUnidadeMedida: 'The abbreviation field must contain at least 2 characters.',
  mensagemCampoNomeFornecedorProdutor: 'The name field must contain at least 5 characters.',
  mensagemCampoCNPJFornecedorProdutor: 'The CNPJ field does not need to be formatted; only the numbers are sufficient.',
  mensagemCampoCNPJLenghtFornecedorProdutor: 'The CNPJ field must contain 14 characters.',
  previsao: 'Forecast',
  cadastrosBasicos: 'Basic registration',
  // Simulação
  Simulacao: 'Simulation',
  simulacao: 'Simulation',
  classificacao: 'Classification',
  filial: 'Affiliate/Benefits',
  solicitadoEm: 'Requested in',
  recuperarSenha: 'Recover password',
  nenhumaEmpresaColuna: 'No company in this column',
  nunhumProcessoEncontrado: 'No new process was found',
  abrirVisualizarAndamentoFollowup: 'You can open a new process or view what is in progress in the Follow-Up',
  tooltipDataLiberacaoSiscarga: 'Release date of the B/L (withdrawal of retention)',
  tooltipDataLiberacaoMapa: 'Date when the ministry of agriculture releases the wooden packaging of the merchandise',
  tooltipPresencaCarga: 'Date when the customs area informs that the container is in the terminal',
  LI: 'LI',
  II: 'II',
  IPI: 'IPI',
  PIS: 'PIS',
  COFINS: 'COFINS',
  'COFINS CUSTO': 'COFINS COST',
  ICMS: 'ICMS',
  'PIS SAIDA': 'PIS OUT',
  'COFINS SAIDA': 'COFINS OUT',
  'MARKTUP': 'MARKTUP',
  'DESCONTO': 'DISCOUNT',
  comissoes: 'Commissions',
  parceiros: 'Importing promotes growth',
  DashboardContainers: "Dashboard",
  min: "Minimum",
  max: "Maximum",
  avg: "Average",
  median: "Median",
  count: "Count",
  escolhaAbaixo: 'Choose below',
  referenciaProcesso: 'Process reference',
  valorComissao: 'Commission amount',
  parcelasPagamento: 'Payment installments',
  dataComissao: 'Commission date',
  icms: 'ICMS',
  valorIcms: 'ICMS Amount',
  tipoImportacao: 'Import Type',
  ocultar: 'Hide',
  exibir: 'Show',
  'Cliente': 'Client',
  nomeArquivo: 'File Name',
  novoProcesso: 'New Process',
  referenciaPO: 'Reference (PO or Invoice)',
  expandirDiminuir: 'Expand / Collapse',
  downloadPDF: 'Download PDF',
  recarregar: 'Refresh',
  // Pré faturamento
  preFaturamento: 'Pre Billing',
  carregamentoProgramado: 'Scheduled loading',
  horario: 'Schedule',
  liberacaoMapa: 'Map release',
  liberacaoSiscarga: 'Siscarga release',
  transportador: 'Carrier',
  taxaCambialDI: 'Exchange rate D.I',
  beneficioFiscal: 'Fiscal benefit',
  descricaoItem: 'Item description',
  despachante: 'Customs broker',
  armazemDesembaraco: 'Clearance warehouse',
  recintoEntrada: 'Entry enclosure',
  codigoInvoice: 'Invoice code',
  quantidadeContainers: 'Quantity of containers',
  quantidadeLIs: 'Quantity of LI\'s',
  diasLivres: 'Free days',
  CE: 'C.E',
  desembaraco: 'Clearance',
  saldoConta: 'Account balance',
  custosAlocadosOutroProcesso: 'Costs allocated from another process',
  THC: 'THC',
  observacoesProcesso: 'Process observations',
  codigo: 'Code',
  emissao: 'Issuance',
  numeroDocumento: 'Doc Number',
  adiantamento: 'Advance',
  descricaoPessoa: 'Person Description',
  uf: 'State',
  numAdicao: 'Admission Number',
  numItem: 'Item Number',
  codigoExportacao: 'Export Code',
  contaProjeto: 'Project Account',
  valorMoedaNacional: 'National Currency Value',
  formaRateio: 'Allocation Method',
  encargo: 'Charge',
  ONU: 'UN',
  descricaoCliente: 'Customer Description',
  embalagem: 'Packaging',
  nomePasta: 'Folder Name',
  informacoesProcesso: 'Process Information',
  financeiroPagar: 'Financial Payable',
  comparativoProdutosDIs: 'Comparative product(s) D.I.',
  comparativoProdutoInvoice: 'Comparative product Invoice',
  custosEmissaoNF: 'Costs for NF issuance',
  produtosProcesso: 'Process Products',
  documentosGED: 'GED Documents',
  comparativosProdutoDIs: 'Comparative product(s) D.I.',
  mensagemRascunhos: 'Resume the information from previous requests that were not completed.',
  editarSolicitacaoProcesso: 'Edit Supply Order',
  prazoPagamento: 'Payment term',
  downloadExcel: 'Descargar tabla en Excel',
  substituta: "Substitute",
  limparFiltros: 'Clear filters',
  valoresInvoice: 'Total invoice products',
  PrevisaoArmazem: 'Warehouse Forecast',
  DiasRestantesChegada: 'Days remaining for arrival',
  dataMovimento: 'Movement date',
  segmentoProduto: "Product segment",
  valorProcesso: "Total process value",
  dataChegouPorto: 'Cargo has arrived at the destination port',
  previsaoDemandaDomestica: 'Domestic demand forecast',
  PrevisaoDemandaDomestica: 'Domestic demand forecast',
  demandaDomestica: 'Domestic demand',
  processosPendentes: 'Pending processes',
  bl: 'BL',
  enviosEmail: 'Email submissions',
  esteProcessoPossui: 'This process has',
  um: 'A',
  acabouAberto: 'has just been opened',
  "tooltipAbertura": "Formal start of the import process with the Trading, beginning legal and administrative procedures.",
  "tooltipDataEmbarque": "Day when the goods are effectively loaded onto the means of transportation to be shipped from the country of origin to the destination country.",
  "tooltipRegistroDI": "The Import Declaration records details such as manufacturer data, importer, tariff classification, and tax values. It is a prerequisite for customs clearance.",
  "tooltipVistoriaMapa": "The Ministry of Agriculture, Livestock, and Supply is responsible for inspecting the international transit of packaging, preventing the entry of pests.",
  "tooltipETA": "Estimated date of arrival of the ship at the port.",
  "tooltipETD": "Estimated date of departure of the ship from the port.",
  "tooltipRecebimentoOriginais": "These are the instructive documents of the process, example: Invoice, packing list, and BL.",
  "tooltipTransbordo": "Goods will have to change ships during the journey, along the route already plotted.",
  "tooltipSegundoTransbordo": "Goods will have to change ships for the second time during the journey, along the route already plotted.",
  "tooltipDataLiberaçãoMapa": "Date on which the Ministry of Agriculture, Livestock, and Supply authorizes the release of goods, through documentary or physical inspection.",
  "tooltipDataChegada": "Moment when the imported goods reach the destination port, marking the beginning of customs and logistical procedures.",
  "tooltipDesembaracoDI": "Customs clearance of the Import Declaration. Includes analysis and approval by customs of import documents, allowing the release of goods.",
  "tooltipConhecimentoEmbarque": "Also known as Bill of Lading (B/L), it serves as a receipt for the shipped goods and as a document of title of possession of the goods during transport.",
  "tooltipEmissãoNotaEntrada": "Generation of fiscal document by the importing company used to formalize the entry of products purchased abroad.",
  "tooltipDataCarregamento": "Date on which the loading of the process is scheduled or has already been carried out.",
  "tooltipExecucaoCarregamento": "Date on which the container was removed from the port.",
  "tooltipCarregamentoAgendado": "Scheduling of the moment when the goods will be loaded onto the vehicle and removed from the port. Not sure if this date exists in Trinity.",
  "tooltipFechamentoOperacional": "Conclusion of logistical and administrative operations related to importation.",
  "tooltipDataFaturamento": "Issuance of the electronic invoice, detailing description of goods, quantities, prices, payment terms, among others.",
  "tooltipEnvioFaturamento": "Date the electronic invoice was sent via the system",
  ForgotPassword: 'Forgot my password',
  consultarProcessos: "Consult processes",
  realizarCotacao: "Perform a quotation",
  documentosGerais: "General documents",
  fretes: "Freights",
  performance: "Performance",
  analiseFrete: "Freight analysis",
  acuraciaEstoque: "Inventory accuracy",
  eficaciaGeral: "Overall effectiveness",
  basicos: "Basics",
  portuariaVigentes: "Current port",
  tarefasComex: "COMEX tasks",
  interno: "Internal",
  armazenamento: "Storage",
  gerais: 'General',
  sugerirTrasnportadora: 'Suggest carrier',
  responsavelFrete: 'Freight responsible',
  agenciamentoInternacional: 'International Agency',
  acuraciaArmazem: 'Overall Effectiveness of Warehousing Operations',
  operacional: 'operational',
  deProcesso: 'of Process',
  esteEMais: 'Esto y mas',
  processosForamEncerrados: 'se cerraron los procesos',
  esteProcessoEncerrado: 'This process has been closed',
};
